import Video from '../components/Video';

export default class DynamicVideo {
  constructor(section) {
    const videoEl = section.el.querySelector('[data-video]');

    if (videoEl) {
      this.video = new Video(section.el.querySelector('[data-video]'));
    }
  }

  onSectionUnload() {
    if (this.video) {
      this.video.unload();
    }
  }
}
